import { Toolbar } from '@mui/x-data-grid-pro';
import { Theme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { StyledQuickFilter } from '../StyledComponents';

import styles from './DataGrid.Broker.module.css';

/**
 * Custom MUI Data Grid Toolbar for the Broker Carrier Data Grid
 */
export default function GridToolbar() {
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	return (
		<Toolbar className={styles['toolbar']}>
			<div className={styles['right-justified']}>
				<StyledQuickFilter
					className={styles['quick-filter']}
					inputClassName={styles['quick-filter-input']}
					placeholder='Filter by Keyword'
					debounceMs={300}
					defaultExpanded={isMobile}
					alwaysExpanded={isMobile ? true : undefined}
				/>
			</div>
		</Toolbar>
	);
}
